export default __webpack_public_path__ + "a58a101ba6cb11aa0974cc6187e4e3e2.png";